import {
  PHONEME_IMPORT_SPEC,
  PHONEME_BACK_TO_INTRO,
  PHONEME_BALLOON_START,
  PHONEME_BASKET_START,
  PHONEME_CLOUD_START,
  PHONEME_CLOUD_SET_ROUND,
  PHONEME_BALLOON_SELECT,
  PHONEME_BALLON_END,
  PHONEME_BALLOON_READY,
  PHONEME_BALLON_NOT_CLICKABLE,
  PHONEME_BALLOON_CLEAR_ANSWER,
  PHONEME_BALLON_READY_END,
  PHONEME_CLOUD_END,
  PHONEME_CLOUD_PLAY,
  PHONEME_CLOUD_PLAY_END,
  PHONEME_CLOUD_PLAY_NEXT,
  PHONEME_CLOUD_CLICK,
  PHONEME_BASKET_SELECT,
  PHONEME_BASKET_RESPONSE,
  PHONEME_BASKET_CLEAR,
  PHONEME_BASKET_END,
  PHONEME_BASKET_READY_END,
  PHONEME_CLOUD_CLICKABLE,
  PHONEME_CLOUD_READY_END,
  PHONEME_FIRST_CLICK,
  PHONEME_INSTRUCTION,
} from "../actions/actionIdentifiers";
import {
  INTRO_STAGE,
  BASKET_STAGE,
  BALLOON_STAGE,
  CLOUD_STAGE,
} from "./stateIdentifiers";

export interface PhonemeState {
  stage: string;
  instruction: boolean;
  firstClicked: boolean;
  mainPhonics: null;
  phonics: string[];
  wrongPhonics: string[];
  // Balloon
  balloonQty: number;
  balloonPhonics: string[];
  balloons: string[];
  balloonAnswered: number[];
  balloonAnswering: number;
  balloonColors: string[];
  balloonReady: boolean;
  balloonCanSelect: boolean;
  balloonReadyExit: boolean;
  // Basket
  basketQty: number;
  words: string[];
  wrongWords: string[];
  basketItems: string[];
  inBasket: string[];
  basketPlaying: number;
  basketChecking: boolean;
  basketResponse: { response: string; index: number };
  basketReadyEnd: boolean;
  // Cloud
  cloudTotalRound: number;
  cloudRound: number;
  cloudAnswer: string;
  cloudDisplay: string[];
  cloudCovered: string[];
  cloudClickable: boolean;
  cloudPlaying: boolean;
  cloudPlayIndex: number;
  cloudPlayNext: boolean;
  cloudReadyEnd: boolean;
}

const initialState: PhonemeState = {
  stage: INTRO_STAGE,
  instruction: false,
  firstClicked: false,
  mainPhonics: null,
  phonics: [],
  wrongPhonics: [],
  // Balloon
  balloonQty: null,
  balloonPhonics: [],
  balloons: [],
  balloonAnswered: [],
  balloonAnswering: null,
  balloonColors: [],
  balloonReady: false,
  balloonCanSelect: false,
  balloonReadyExit: false,
  // Basket
  basketQty: null,
  words: [],
  wrongWords: [],
  basketItems: [],
  inBasket: [],
  basketPlaying: null,
  basketChecking: false,
  basketResponse: null,
  basketReadyEnd: false,
  // Cloud
  cloudTotalRound: null,
  cloudRound: 0,
  cloudAnswer: null,
  cloudDisplay: [],
  cloudCovered: [],
  cloudClickable: false,
  cloudPlaying: false,
  cloudPlayIndex: 0,
  cloudPlayNext: false,
  cloudReadyEnd: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PHONEME_IMPORT_SPEC:
      return { ...state, ...payload };
    case PHONEME_INSTRUCTION:
      return { ...state, instruction: payload.instruction };
    case PHONEME_BACK_TO_INTRO:
      return { ...state, stage: INTRO_STAGE };
    case PHONEME_FIRST_CLICK:
      return { ...state, firstClicked: true };
    case PHONEME_BALLOON_START:
      return { ...state, ...payload };
    case PHONEME_BALLOON_READY:
      return { ...state, balloonReady: true, balloonCanSelect: true };
    case PHONEME_BALLOON_SELECT:
      return { ...state, ...payload };
    case PHONEME_BALLOON_CLEAR_ANSWER:
      return { ...state, balloonAnswering: null };
    case PHONEME_BALLON_NOT_CLICKABLE:
      return { ...state, balloonCanSelect: false };
    case PHONEME_BALLON_END:
      return { ...state, stage: INTRO_STAGE };
    case PHONEME_BALLON_READY_END:
      return { ...state, balloonReadyExit: true };
    case PHONEME_BALLON_END:
      return { ...state, stage: INTRO_STAGE };
    case PHONEME_BASKET_START:
      return { ...state, ...payload };
    case PHONEME_BASKET_SELECT:
      return { ...state, ...payload };
    case PHONEME_BASKET_RESPONSE:
      return { ...state, ...payload };
    case PHONEME_BASKET_CLEAR:
      return { ...state, ...payload };
    case PHONEME_BASKET_READY_END:
      return { ...state, basketReadyEnd: true };
    case PHONEME_BASKET_END:
      return { ...state, stage: INTRO_STAGE };
    case PHONEME_CLOUD_START:
      return { ...state, ...payload };
    case PHONEME_CLOUD_SET_ROUND:
      return { ...state, ...payload };
    case PHONEME_CLOUD_CLICKABLE:
      return { ...state, cloudClickable: true };
    case PHONEME_CLOUD_PLAY:
      return { ...state, ...payload };
    case PHONEME_CLOUD_PLAY_END:
      return { ...state, cloudPlaying: false };
    case PHONEME_CLOUD_PLAY_NEXT:
      return { ...state, cloudPlayNext: true };
    case PHONEME_CLOUD_CLICK:
      return { ...state, ...payload };
    case PHONEME_CLOUD_READY_END:
      return { ...state, cloudReadyEnd: true };
    case PHONEME_CLOUD_END:
      return { ...state, stage: INTRO_STAGE };
    default:
      return state;
  }
};
